export enum ClickAction {
  TAB_NEWWORKS = 3000,
  TAB_ALLWORKS = 3001,
  COCOCRUSH_EARRINGS_STACKINGS = 3002,
  COCOCRUSH_BRACELETS_STACKINGS = 3003,
  NEWWORKS_OF_RINGS = 3004,
  NEWWORKS_OF_BRACELETS = 3005,
  NEWWORKS_OF_EARRINGS = 3006,
  NEWWORKS_OF_WATCHES = 3007,
  COCOCRUSH_RINGS = 3008,
  PREMIERE_EDITION_ORIGINALE_WATCH = 3009,
  WATCH_H5699 = 3010,
  WATCH_H6951 = 3011,
  WATCH_H5697 = 3012,
  WATCH_H5703 = 3013,
  WATCH_H5696 = 3014,
  WATCH_H5700 = 3015,
  WATCH_H5701 = 3016,
  WATCH_H5705 = 3017,
  WATCH_H5702 = 3018,
  ALLWORKS_OF_RINGS = 3019,
  ALLWORKS_OF_EARRINGS = 3020,
  ALLWORKS_OF_BRACELETS = 3021,
  ALLWORKS_OF_WATCHES = 3022,
  SELECT_PRODUCT = 3023,
  SCROLL_TO_PRODUCT = 3024,
  JUMP_TO_PRODUCT = 3025,
  FILTER = 3026,
  SNAPSHOT = 3027,
  BACK = 3028,
  LONGPRESS = 3029,
  COUNTER = 3030,
  STACKING_CARD = 3031,
  STACKING_BAR = 3032,
  STACKING_TILE = 3033,
  JUMP_TO_WORK = 3034,
  MATERIAL = 3035,
  CANCEL_ALERT = 3036,
  CLOSE_ALERT = 3037,
  RELOAD_PAGE = 3038
}

export const report_descriptions: Record<ClickAction, string> = {
  3000: '精选作品tab点击',
  3001: '所有作品tab点击',
  3002: '精选作品CocoCrush 耳环叠戴的艺术“虚拟体验”点击',
  // 3003: '精选作品CocoCrush 手镯及手链叠戴的艺术“虚拟体验”点击',
  3003: '精选作品CocoCrush 手镯叠戴的艺术“虚拟体验”点击',
  3004: '精选作品分类轮播戒指“虚拟体验”点击',
  // 3005: '精选作品分类轮播手镯及手链“虚拟体验”点击',
  3005: '精选作品分类轮播手镯“虚拟体验”点击',
  3006: '精选作品分类轮播耳环“虚拟体验”点击',
  3007: '精选作品分类轮播腕表“虚拟体验”点击',
  3008: '精选作品COCO CRUSH戒指“虚拟体验”点击',
  3009: '精选作品 PREMIERE EDITION ORIGINALE “虚拟体验”点击',
  3010: '精选作品腕表轮播腕表J12 CALIBER 12.2 腕表 33 毫米“虚拟体验”点击(白色)',
  3011: '精选作品腕表轮播腕表PREMIÈRE ÉDITION ORIGINALE 腕表“虚拟体验”点击',
  3012: '精选作品腕表轮播腕表J12 CALIBER 12.1腕表 38 毫米“虚拟体验”点击(黑色)',
  3013: '精选作品腕表轮播腕表J12 腕表 33 毫米“虚拟体验”点击（白色）',
  3014: '精选作品腕表轮播腕表J12 CALIBER 12.2 腕表 33 毫米“虚拟体验”点击（黑色）',
  3015: '精选作品腕表轮播腕表J12 CALIBER 12.1腕表 38 毫米“虚拟体验”点击(白色)',
  3016: '精选作品腕表轮播腕表J12 腕表 33 毫米“虚拟体验”点击（黑色）',
  3017: '精选作品腕表轮播腕表J12 CALIBER 12.1腕表 38 毫米“虚拟体验”点击(镶钻白色)',
  3018: '精选作品腕表轮播腕表J12 CALIBER 12.1腕表 38 毫米“虚拟体验”点击(镶钻黑色)',
  3019: '所有作品“戒指”点击',
  3020: '所有作品“耳环”点击',
  // 3021: '所有作品“手镯及手链”点击',
  3021: '所有作品“手镯”点击',
  3022: '所有作品“腕表”点击',
  3023: '所有作品产品ICON点击',
  3024: '所有作品产品试戴（点击和滑动终止定位，Call 试戴API时触发）',
  3025: '所有作品“了解更多”点击',
  3026: '所有作品“筛选条件”点击',
  3027: '所有作品“拍照”点击',
  3028: '所有作品“返回”点击',
  3029: '所有作品长按图片事件监听',
  3030: '所有作品“N个造型”点击（展开叠戴列表面板）',
  3031: '所有作品叠戴卡片点击',
  3032: '所有作品叠戴横按点击',
  3033: '所有作品叠戴面板点击（点击后面板展开）',
  3034: '所有作品“探索作品”点击',
  3035: '所有作品材质点击',
  3036: '弹窗右上角关闭按钮点击',
  3037: '“我已知晓”点击',
  3038: '“确认开启”点击'
}
